import { Component, inject, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CredentialRequired } from 'services/credential.service';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { DomainService } from 'services/domain.service';
import { SelectListItemModel } from 'models/SelectList';
import { NavigationService } from 'services/navigation.service';
import { CredentialType } from 'enums/CredentialType';
import { ProductService } from 'services/product.service';
import { ProductPlanTagConstants } from 'constants/ProductPlanTagConstants';
import { ProductVariantModel } from 'models/generated/Entities.GormCrm.ProductVariant';
import { Inputs } from 'modules/inputs';
import { DomainModel } from 'models/generated/Distribution.Api.Models.Domain';
import { CompanyDataProviderFactory } from 'services/company-data-provider';
import { FormValidationService } from 'services/form-validation.service';
import { NewDomainProductPlanInputComponent } from './new-domain-product-plan-input.component';

@Component({
	selector: 'request-transfer',
	templateUrl: './request-domain-transfer.component.html',
	imports: [FormsModule, Layout, Inputs, TranslatePipe, NewDomainProductPlanInputComponent],
	providers: [CompanyDataProviderFactory, FormValidationService]
})
@CredentialRequired(CredentialType.DomainRedelegate)
export class RequestDomainTransferComponent {

	@Input() domain?: DomainModel;
	@ViewChild(NewDomainProductPlanInputComponent) newProductPlan?: NewDomainProductPlanInputComponent;
	authId: string = '';

	private readonly navigation = inject(NavigationService);
	private readonly domainService = inject(DomainService);
	private readonly dataProviderFactory = inject(CompanyDataProviderFactory);

	canConfirm() {
		return !!this.domain && this.newProductPlan?.isValid;
	}

	async confirm() {
		if (!this.domain?.id || !this.domain?.companyId || !this.newProductPlan?.selectedVariant?.id || !this.newProductPlan?.brandId || !this.newProductPlan?.isValid) return;

		const dataProvider = this.dataProviderFactory.getProviderForCompanyId(this.domain.companyId);
		const registrantInfo = this.domainService.getRegistrantInfo(await dataProvider.getCompany());
		await this.domainService.transferDomainToRegistrar(this.domain.id, registrantInfo, this.authId, this.newProductPlan.selectedVariant.id, this.newProductPlan.brandId, this.newProductPlan?.price);

		this.close();
	}

	close() {
		this.navigation.closeView(this);
	}
}
